let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("h4k4y"), load("fGT64"), load("jkPqm"), load("7whwt"), load("6aruy")]).then(() => parcelRequire('9VKkC'));